import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Comment\AddReactionToACommentController::__invoke
* @see app/Http/Controllers/Comment/AddReactionToACommentController.php
* @route '/api/comment/react/{comment}'
*/
const AddReactionToACommentController = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AddReactionToACommentController.url(args, options),
    method: 'put',
})

AddReactionToACommentController.definition = {
    methods: ["put"],
    url: '/api/comment/react/{comment}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Comment\AddReactionToACommentController::__invoke
* @see app/Http/Controllers/Comment/AddReactionToACommentController.php
* @route '/api/comment/react/{comment}'
*/
AddReactionToACommentController.url = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { comment: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { comment: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            comment: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        comment: typeof args.comment === 'object'
        ? args.comment.id
        : args.comment,
    }

    return AddReactionToACommentController.definition.url
            .replace('{comment}', parsedArgs.comment.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Comment\AddReactionToACommentController::__invoke
* @see app/Http/Controllers/Comment/AddReactionToACommentController.php
* @route '/api/comment/react/{comment}'
*/
AddReactionToACommentController.put = (args: { comment: string | number | { id: string | number } } | [comment: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: AddReactionToACommentController.url(args, options),
    method: 'put',
})

export default AddReactionToACommentController